import { Injectable } from '@angular/core'

const STORAGE_KEY = 'albert.postLoginRedirectUrl'
const FALLBACK_URL = '/'
const CALLBACK_PATH = '/auth/callback'

@Injectable({ providedIn: 'root' })
export class AuthRedirectService {

  public store(url: string): void {
    if (!this.isInAppUrl(url) || url.startsWith(CALLBACK_PATH)) {
      return
    }

    try {
      sessionStorage.setItem(STORAGE_KEY, url)
    } catch {
      // Storage can be unavailable (private mode, blocked cookies); losing the
      // deep link is acceptable, breaking the login flow is not.
    }
  }

  public consume(): string {
    let stored: string | null = null

    try {
      stored = sessionStorage.getItem(STORAGE_KEY)
      sessionStorage.removeItem(STORAGE_KEY)
    } catch {
      // See store(): treat an unreadable storage as "nothing stored".
    }

    return stored !== null && this.isInAppUrl(stored) ? stored : FALLBACK_URL
  }
  
  private isInAppUrl(url: string): boolean {
    return url.startsWith('/') && !url.startsWith('//') && !url.startsWith('/\\')
  }
}
